import { Button, Col, Row } from "react-bootstrap";
import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../appContext/AppContext";
import { searchOptionNhanVien, searchOptionVaiTro } from "../services/services";
import { MAX_PAGE_SIZE } from "../../../../utils/Constant";
import { toast } from "react-toastify";
import {
  TYPE_KE_HOACH_DAO_TAO
} from "../../../../quan-ly-khao-sat/Components/danh-sach-ke-hoach/constants/constansKeHoach";
import TableNhanLuc from "./TableNhanLuc";
import LabelRequired from "../../../../component/LabelRequired";
import AutocompleteObjectV2 from "../../../../component/AutocompleteObjectV2";

interface Props {
  dataNhanLuc: {
    tuyenTren: any[];
    tuyenDuoi: any[];
  };
  setDataNhanLuc: Dispatch<SetStateAction<any>>;
  isView: boolean;
}

const NhanLuc = (props: Props) => {
  const { dataNhanLuc, setDataNhanLuc, isView } = props;
  const { setIsLoading } = useContext(AppContext);

  const [thanhVien, setThanhVien] = useState<any>([]);
  const [vaiTro, setVaiTro] = useState<any>([]);

  const [selectedNhanSuTren, setSelectedNhanSuTren] = useState<any>(null);
  const [selectedVaiTroTren, setSelectedVaiTroTren] = useState<any>(null);
  const [editingIndexTren, setEditingIndexTren] = useState<number | null>(null);

  const [selectedNhanSuDuoi, setSelectedNhanSuDuoi] = useState<any>(null);
  const [selectedVaiTroDuoi, setSelectedVaiTroDuoi] = useState<any>(null);
  const [editingIndexDuoi, setEditingIndexDuoi] = useState<number | null>(null);

  const getOptions = async () => {
    try {
      setIsLoading(true);
      const [nhanVien, vaiTroRes] = await Promise.all([
        searchOptionNhanVien({ pageSize: MAX_PAGE_SIZE }),
        searchOptionVaiTro({ pageSize: MAX_PAGE_SIZE })
      ]);

      setThanhVien(nhanVien?.data?.data?.content ?? []);
      setVaiTro(vaiTroRes?.data?.data?.content ?? []);
    } catch (e) {
      console.error("Lỗi khi tải danh sách:", e);
      toast.error("Không thể tải danh sách nhân viên và vai trò");
    } finally {
      setIsLoading(false);
    }
  };
  const handlerSelectItem = (item: any, lst: any) => {
    const isDuplicate = lst?.some((items: any) => items?.item.code === item.code);
    if (isDuplicate) {
      toast.warning("Đã có nhân sự này!");
      return true
    }
  }
  const handleAddOrUpdateTuyenTren = () => {
    if (!selectedNhanSuTren || !selectedVaiTroTren) {
      toast.warning('Vui lòng chọn đầy đủ nhân sự và vai trò');
      return;
    }
    if (handlerSelectItem(selectedNhanSuTren, dataNhanLuc?.tuyenTren || [])) return

    const newItem = {
      levelType: "UPPER",
      personnel: selectedNhanSuTren.code || "",
      personnelName: selectedNhanSuTren.name || "",
      position: selectedNhanSuTren.position || "",
      positionName: selectedNhanSuTren.chucVu || "",
      unit: selectedNhanSuTren?.unitName || selectedNhanSuTren?.department || "",
      unitName: selectedNhanSuTren?.unitName || selectedNhanSuTren?.department || "",
      degree: "",
      degreeName: "",
      role: selectedVaiTroTren.code || "",
      roleName: selectedVaiTroTren.name || "",
      experience: "",
      currentCapacity: "",
      currentCapacityName: "",
      item: selectedNhanSuTren,
      vaiTro: selectedVaiTroTren
    };

    if (editingIndexTren !== null) {
      const updatedList = [...dataNhanLuc.tuyenTren];
      updatedList[editingIndexTren] = newItem;
      setDataNhanLuc({ ...dataNhanLuc, tuyenTren: updatedList });
      setEditingIndexTren(null);
      toast.success('Cập nhật thành công');
    } else {
      setDataNhanLuc({ ...dataNhanLuc, tuyenTren: [newItem, ...dataNhanLuc.tuyenTren] });
      toast.success('Thêm thành công');
    }

    setSelectedNhanSuTren(null);
    setSelectedVaiTroTren(null);
  };

  const handleAddOrUpdateTuyenDuoi = () => {
    if (!selectedNhanSuDuoi || !selectedVaiTroDuoi) {
      toast.warning('Vui lòng chọn đầy đủ nhân sự và vai trò');
      return;
    }

    if (handlerSelectItem(selectedNhanSuDuoi, dataNhanLuc?.tuyenDuoi || [])) return

    const newItem = {
      levelType: "LOWER",
      personnel: selectedNhanSuDuoi.code || "",
      personnelName: selectedNhanSuDuoi.name || "",
      position: selectedNhanSuDuoi.position || "",
      positionName: selectedNhanSuDuoi.chucVu || "",
      unit: selectedNhanSuDuoi?.unitName || selectedNhanSuDuoi?.department || "",
      unitName: selectedNhanSuDuoi?.unitName || selectedNhanSuDuoi?.department || "",
      degree: "",
      degreeName: "",
      role: selectedVaiTroDuoi.code || "",
      roleName: selectedVaiTroDuoi.name || "",
      experience: "",
      currentCapacity: "",
      currentCapacityName: "",
      item: selectedNhanSuDuoi,
      vaiTro: selectedVaiTroDuoi
    };

    if (editingIndexDuoi !== null) {
      const updatedList = [...dataNhanLuc.tuyenDuoi];
      updatedList[editingIndexDuoi] = newItem;
      setDataNhanLuc({ ...dataNhanLuc, tuyenDuoi: updatedList });
      setEditingIndexDuoi(null);
      toast.success('Cập nhật thành công');
    } else {
      setDataNhanLuc({ ...dataNhanLuc, tuyenDuoi: [newItem, ...dataNhanLuc.tuyenDuoi] });
      toast.success('Thêm thành công');
    }

    setSelectedNhanSuDuoi(null);
    setSelectedVaiTroDuoi(null);
  };

  const handleEditTuyenTren = (row: any, index: number) => {
    setSelectedNhanSuTren(row.item);
    setSelectedVaiTroTren(row.vaiTro);
    setEditingIndexTren(index);
  };

  const handleDeleteTuyenTren = (index: number) => {
    const updatedList = dataNhanLuc.tuyenTren.filter((_: any, i: number) => i !== index);
    setDataNhanLuc({ ...dataNhanLuc, tuyenTren: updatedList });
    toast.success('Xóa thành công');
  };

  const handleEditTuyenDuoi = (row: any, index: number) => {
    setSelectedNhanSuDuoi(row.item);
    setSelectedVaiTroDuoi(row.vaiTro);
    setEditingIndexDuoi(index);
  };

  const handleDeleteTuyenDuoi = (index: number) => {
    const updatedList = dataNhanLuc.tuyenDuoi.filter((_: any, i: number) => i !== index);
    setDataNhanLuc({ ...dataNhanLuc, tuyenDuoi: updatedList });
    toast.success('Xóa thành công');
  };

  const handleCancelEditTren = () => {
    setEditingIndexTren(null);
    setSelectedNhanSuTren(null);
    setSelectedVaiTroTren(null);
  };

  const handleCancelEditDuoi = () => {
    setEditingIndexDuoi(null);
    setSelectedNhanSuDuoi(null);
    setSelectedVaiTroDuoi(null);
  };

  useEffect(() => {
    getOptions();
  }, []);

  const columnsDkDaoTao = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 100,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              <i
                onClick={() => handleEditTuyenTren(row, index)}
                className="bi bi-pencil-square text-navy cursor-pointer"
                style={{ cursor: 'pointer', marginRight: '10px' }}
                title="Sửa"
              ></i>
              <i
                onClick={() => handleDeleteTuyenTren(index)}
                className="bi bi-trash3-fill text-danger cursor-pointer"
                style={{ cursor: 'pointer' }}
                title="Xóa"
              ></i>
            </div>
        },
      ] : []),
    {
      name: "Họ tên",
      field: "personnelName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.personnelName || row.item?.personnelName || '',
    },
    {
      name: "Chức danh",
      field: "position",
      headerStyle: {
        minWidth: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.position || row.item?.position || '',
    },
    {
      name: "Đơn vị",
      field: "unitName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.unitName || row.item?.unitName || '',
    },
    {
      name: "Trình độ chuyên môn",
      field: "quantityOfficer",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.quantityOfficer || row.item?.quantityOfficer || '',
    },
    {
      name: "Vai trò",
      field: "role",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.role || row.vaiTro?.name || '',
    },
  ];

  const columnsTuyenDuoi = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 100,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              <i
                onClick={() => handleEditTuyenDuoi(row, index)}
                className="bi bi-pencil-square text-navy cursor-pointer"
                style={{ cursor: 'pointer', marginRight: '10px' }}
                title="Sửa"
              ></i>
              <i
                onClick={() => handleDeleteTuyenDuoi(index)}
                className="bi bi-trash3-fill text-danger cursor-pointer"
                style={{ cursor: 'pointer' }}
                title="Xóa"
              ></i>
            </div>
        },
      ] : []),
    {
      name: "Họ tên",
      field: "personnelName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.personnelName || row.item?.personnelName || '',
    },
    {
      name: "Chức danh",
      field: "position",
      headerStyle: {
        minWidth: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.position || row.item?.position || '',
    },
    {
      name: "Đơn vị",
      field: "unitName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.unitName || row.item?.unitName || '',
    },
    {
      name: "Trình độ chuyên môn",
      field: "quantityOfficer",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.quantityOfficer || row.item?.quantityOfficer || '',
    },
    {
      name: "Vai trò",
      field: "role",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.role || row.vaiTro?.name || '',
    },
  ];

  return (
    <div className="spaces px-10">
      {/* TUYẾN TRÊN */}
      <h4 className="text-title fw-bold fs-5 spaces mb-5">
        Nhân lực tuyến trên
      </h4>

      {!isView && (
        <Row className="mb-4">
          <Col lg={1} className="spaces">
            <div className="spaces pt-10 min-w-135">
              <div className="spaces mt-1">
                <LabelRequired className="min-w-100px" label="Nhân sự" />
              </div>
            </div>
          </Col>
          <Col lg={4} className="spaces pl-36">
            <AutocompleteObjectV2
              options={thanhVien}
              value={selectedNhanSuTren}
              isSearchDefauilt={true}
              name="WmsCode"
              onChange={(options: any) => setSelectedNhanSuTren(options)}
              className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
              isClearable={true}
              placeholder="Chọn nhân sự..."
            />
          </Col>
          <Col lg={1} className="spaces">
            <div className="spaces pt-10 min-w-135">
              <div className="spaces mt-1">
                <LabelRequired className="min-w-100px" label="Vai trò" />
              </div>
            </div>
          </Col>
          <Col lg={4} className="spaces pl-36">
            <AutocompleteObjectV2
              options={vaiTro}
              value={selectedVaiTroTren}
              isSearchDefauilt={true}
              name="WmsCode"
              onChange={(options: any) => setSelectedVaiTroTren(options)}
              className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
              isClearable={true}
              placeholder="Chọn vai trò..."
            />
          </Col>
          <Col lg={2}>
            <div className="d-flex mt-8 spaces align-items-center">
              <Button
                className="btn-fill spaces min-w-90px btn btn-primary"
                onClick={handleAddOrUpdateTuyenTren}
                type="button"
              >
                <i className="bi bi-plus-lg text-pri fs-3"></i>
                {editingIndexTren !== null ? 'Cập nhật' : 'Thêm'}
              </Button>
              {editingIndexTren !== null && (
                <Button
                  className="btn-fill spaces min-w-90px btn btn-secondary ms-2"
                  onClick={handleCancelEditTren}
                  type="button"
                >
                  Hủy
                </Button>
              )}
            </div>
          </Col>
        </Row>
      )}

      <TableNhanLuc
        columns={columnsDkDaoTao}
        isView={isView}
        dsItems={dataNhanLuc?.tuyenTren ?? []}
      />

      {/* TUYẾN DƯỚI */}
      <h4 className="text-title fw-bold fs-5 spaces mb-5 mt-20">
        Nhân lực tuyến dưới
      </h4>

      {!isView && (
        <Row className="mb-4">
          <Col lg={1} className="spaces">
            <div className="spaces pt-10 min-w-135">
              <div className="spaces mt-1">
                <LabelRequired className="min-w-100px" label="Nhân sự" />
              </div>
            </div>
          </Col>
          <Col lg={4} className="spaces pl-36">
            <AutocompleteObjectV2
              options={thanhVien}
              value={selectedNhanSuDuoi}
              isSearchDefauilt={true}
              name="WmsCode"
              onChange={(options: any) => setSelectedNhanSuDuoi(options)}
              className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
              isClearable={true}
              placeholder="Chọn nhân sự..."
            />
          </Col>
          <Col lg={1} className="spaces">
            <div className="spaces pt-10 min-w-135">
              <div className="spaces mt-1">
                <LabelRequired className="min-w-100px" label="Vai trò" />
              </div>
            </div>
          </Col>
          <Col lg={4} className="spaces pl-36">
            <AutocompleteObjectV2
              options={vaiTro}
              value={selectedVaiTroDuoi}
              isSearchDefauilt={true}
              name="WmsCode"
              onChange={(options: any) => setSelectedVaiTroDuoi(options)}
              className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
              isClearable={true}
              placeholder="Chọn vai trò..."
            />
          </Col>
          <Col lg={2}>
            <div className="d-flex mt-8 spaces align-items-center">
              <Button
                className="btn-fill spaces min-w-90px btn btn-primary"
                onClick={handleAddOrUpdateTuyenDuoi}
                type="button"
              >
                <i className="bi bi-plus-lg text-pri fs-3"></i>
                {editingIndexDuoi !== null ? 'Cập nhật' : 'Thêm'}
              </Button>
              {editingIndexDuoi !== null && (
                <Button
                  className="btn-fill spaces min-w-90px btn btn-secondary ms-2"
                  onClick={handleCancelEditDuoi}
                  type="button"
                >
                  Hủy
                </Button>
              )}
            </div>
          </Col>
        </Row>
      )}

      <TableNhanLuc
        columns={columnsTuyenDuoi}
        isView={isView}
        dsItems={dataNhanLuc?.tuyenDuoi ?? []}
      />
    </div>
  );
};

export default NhanLuc;